module.exports = __webpack_public_path__ + "img/icon_pc_moon.698c2be.webp";